import { actionTypes as documentEditorActionTypes } from "Areas/Documents/documentEditorPanel";
import documentsActionTypes from "Areas/Documents/redux/actionTypes";
import { actionTypes as projectEditorActionTypes } from "Areas/Projects/projectEditorPanel";
import projectsActionTypes from "Areas/Projects/redux/actionTypes";
import summaryReportsActionTypes from "Areas/SummaryReports/redux/actionTypes";
import { actionTypes as summaryReportEditorActionTypes } from "Areas/SummaryReports/summaryReportEditorPanel";
import workSpacesActionTypes from "Areas/WorkSpaces/redux/actionTypes";
import createReducer from "Common/reducerUtils/createReducer";
import set from "Common/reducerUtils/set";
import filter from "lodash/filter";
import find from "lodash/find";
import findIndex from "lodash/findIndex";
import flatMap from "lodash/flatMap";
import keyBy from "lodash/keyBy";
import map from "lodash/map";
import omit from "lodash/omit";
import reject from "lodash/reject";
import values from "lodash/values";
import { NAMESPACE } from "../constants";
import actionTypes from "./actionTypes";
export const initialState = {
    [NAMESPACE]: { data: {}, summaryReports: {}, tab: 0 }
};
export default createReducer(initialState, {
    [actionTypes.GET_PROJECT_COMPLETED]: (state, { payload }) => set(state, `[${NAMESPACE}].data[${payload.Id}]`, payload),
    [actionTypes.GET_PROJECT_SUMMARY_REPORTS_COMPLETED]: (state, { payload, meta }) => set(state, `[${NAMESPACE}].summaryReports[${meta.projectId}]`, keyBy(payload, "Id")),
    [actionTypes.SET_TAB]: (state, { tab }) => set(state, `[${NAMESPACE}].tab`, tab),
    [workSpacesActionTypes.DELETE_WORK_SPACE_COMPLETED]: (state, { meta }) => {
        const projectIds = map(filter(values(state[NAMESPACE].data), ["WorkSpaceId", meta.workSpaceId]), "Id");
        const result = set(state, `[${NAMESPACE}].data`, omit(state[NAMESPACE].data, projectIds));
        return set(result, `[${NAMESPACE}].summaryReports`, omit(state[NAMESPACE].summaryReports, projectIds));
    },
    [projectsActionTypes.DELETE_PROJECT_COMPLETED]: (state, { meta }) => {
        const result = set(state, `[${NAMESPACE}].data`, omit(state[NAMESPACE].data, meta.projectId));
        return set(result, `[${NAMESPACE}].summaryReports`, omit(state[NAMESPACE].summaryReports, meta.projectId));
    },
    [documentsActionTypes.DELETE_DOCUMENT_COMPLETED]: (state, { meta }) => {
        var _a;
        return set(state, `[${NAMESPACE}].data[${meta.projectId}].Documents`, reject((_a = state[NAMESPACE].data[meta.projectId]) === null || _a === void 0 ? void 0 : _a.Documents, ["Id", meta.documentId]), {
            checkExistence: true,
            checkEqual: false
        });
    },
    [summaryReportsActionTypes.DELETE_SUMMARY_REPORT_COMPLETED]: (state, { meta }) => {
        const summaryReport = find(flatMap(values(state[NAMESPACE].summaryReports), e => values(e)), ["Id", meta.summaryReportId]);
        if (!summaryReport || !state[NAMESPACE].summaryReports[summaryReport.ProjectId])
            return state;
        return set(state, `[${NAMESPACE}].summaryReports[${summaryReport.ProjectId}]`, omit(state[NAMESPACE].summaryReports[summaryReport.ProjectId], meta.summaryReportId));
    },
    [projectEditorActionTypes.SAVE_PROJECT_COMPLETED]: (state, { payload }) => {
        const resultData = state[NAMESPACE].data[payload.Id]
            ? { ...state[NAMESPACE].data[payload.Id], ...payload }
            : payload;
        return set(state, `[${NAMESPACE}].data[${payload.Id}]`, resultData);
    },
    [documentEditorActionTypes.SAVE_DOCUMENT_COMPLETED]: (state, { payload }) => {
        var _a;
        const documents = (_a = state[NAMESPACE].data[payload.ProjectId]) === null || _a === void 0 ? void 0 : _a.Documents;
        if (!documents)
            return state;
        const documentIndex = findIndex(documents, ["Id", payload.Id]);
        const indexToInsertOrUpdate = documentIndex !== -1 ? documentIndex : documents.length;
        return set(state, `[${NAMESPACE}].data[${payload.ProjectId}].Documents[${indexToInsertOrUpdate}]`, payload, {
            checkExistence: false,
            checkEqual: true
        });
    },
    [documentEditorActionTypes.DUPLICATE_DOCUMENT_COMPLETED]: (state, { payload }) => {
        var _a;
        const documents = (_a = state[NAMESPACE].data[payload.ProjectId]) === null || _a === void 0 ? void 0 : _a.Documents;
        if (!documents)
            return state;
        const indexToInsert = documents.length;
        return set(state, `[${NAMESPACE}].data[${payload.ProjectId}].Documents[${indexToInsert}]`, payload, {
            checkExistence: false,
            checkEqual: false
        });
    },
    [summaryReportEditorActionTypes.SAVE_SUMMARY_REPORT_COMPLETED]: (state, { payload }) => !state[NAMESPACE].summaryReports[payload.ProjectId]
        ? set(state, `[${NAMESPACE}].summaryReports[${payload.ProjectId}]`, {
            [payload.Id]: payload
        })
        : set(state, `[${NAMESPACE}].summaryReports[${payload.ProjectId}][${payload.Id}]`, payload)
});
